module.exports = __webpack_public_path__ + "img/winerackdog46.3688ee57.jpg";